module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/paypal-defc8e2bd996b1d6f426343da8003095.svg";